import { useId } from 'react';

import dayjs from 'dayjs';

import type { TypeDateRangePickerCalendarRendererProps } from '@thefarmersfront/kitchen-mobile';
import { BottomSheet, DateRangePickerCalendar, Text } from '@thefarmersfront/kitchen-mobile';

import { formatDate } from '~/utils';

type TypeFocusFieldsProps = {
  calendarConfig: TypeDateRangePickerCalendarRendererProps['calendarConfig'];
};

/** @description 기간 선택 바텀시트 */
const DateRangePickerBottomSheet = ({
  isCalendarOpen,
  setIsCalendarOpen,
  calendarConfig,
  onConfirm,
}: TypeDateRangePickerCalendarRendererProps) => {
  const id = useId();

  return (
    <BottomSheet
      id={'date-range-picker-bottom-sheet' + id}
      open={isCalendarOpen}
      onClose={() => setIsCalendarOpen(false)}
      buttonConfig={{
        buttonType: 'alert',
        confirmText: '기간 선택',
        onConfirm,
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', alignItems: 'center' }}>
        <FocusFields calendarConfig={calendarConfig} />
        <DateRangePickerCalendar {...calendarConfig} />
      </div>
    </BottomSheet>
  );
};

const FocusFields = ({ calendarConfig }: TypeFocusFieldsProps) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', width: '100%', maxWidth: '328px' }}>
      <div
        style={{
          padding: '13px 16px',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '2px',
          backgroundColor: '#FBF7FF',
          borderRadius: '10px',
        }}
      >
        <Text size="small" weight="regular" color="point">
          시작일
        </Text>
        <Text size="xlarge" weight="semi-bold" color={calendarConfig.startDate ? 'primary' : 'disabled'}>
          {calendarConfig.startDate ? formatDate({ value: dayjs(calendarConfig.startDate), separator: '.' }) : '-'}
        </Text>
      </div>
      <div
        style={{
          padding: '13px 16px',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '2px',
          backgroundColor: '#FBF7FF',
          borderRadius: '10px',
        }}
      >
        <Text size="small" weight="regular" color="point">
          종료일
        </Text>
        <Text size="xlarge" weight="semi-bold" color={calendarConfig.endDate ? 'primary' : 'disabled'}>
          {calendarConfig.endDate ? formatDate({ value: dayjs(calendarConfig.endDate), separator: '.' }) : '-'}
        </Text>
      </div>
    </div>
  );
};

export default DateRangePickerBottomSheet;
